import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { person } from "../../../../store/person/actions";
export var useGetPerson = function (trigger, personData) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePerson: (_a = state.Person.responsePerson) === null || _a === void 0 ? void 0 : _a.data,
            loadingPerson: state.Person.loadingPerson,
            errorPerson: state.Person.errorPerson,
        });
    }), responsePerson = _a.responsePerson, loadingPerson = _a.loadingPerson, errorPerson = _a.errorPerson;
    useEffect(function () {
        if (trigger && (personData === null || personData === void 0 ? void 0 : personData.documentNumber)) {
            var document = personData.documentNumber.replace(/-/g, "");
            dispatch(person({
                enable: true,
                page: 1,
                limit: 100000,
                numberId: document,
            }));
        }
    }, [trigger, personData === null || personData === void 0 ? void 0 : personData.documentNumber]);
    return {
        responsePerson: responsePerson,
        loadingPerson: loadingPerson,
        errorPerson: errorPerson,
    };
};
